export default "__VITE_ASSET__BHh9vzXk__"